import PropTypes from 'prop-types';

export const vehicleTypes = PropTypes.shape({
    Brand: PropTypes.string.isRequired,
    Dealer: PropTypes.string.isRequired,
    ExpirationDate: PropTypes.string.isRequired,
    FinancialOperation: PropTypes.string.isRequired,
    FromDateAmount: PropTypes.string.isRequired,
    Id: PropTypes.string.isRequired,
    Manager: PropTypes.string.isRequired,
    MinimumPrice: PropTypes.number.isRequired,
    Model: PropTypes.string.isRequired,
    Plate: PropTypes.string.isRequired,
    ProductName: PropTypes.string.isRequired,
    Status: PropTypes.string.isRequired, //unused
}).isRequired;

export const priceTypes = PropTypes.shape({
    AmountWithTaxes: PropTypes.number.isRequired,
    AmountWithoutTaxes: PropTypes.number.isRequired,
    FromDate: PropTypes.string.isRequired,
    IsActivePrice: PropTypes.bool.isRequired,
    ManualPrice: PropTypes.bool.isRequired, //unused
    OwnershipChange: PropTypes.number.isRequired,
}).isRequired;
